import { Suspense, useEffect, useMemo } from "react";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';

import { useDataFetch } from "../../../../hooks/useDataFetch2";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import { useColumnsDividendosCuadrados } from "../utils/columnsDividendosImpagos";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { exportExcel } from "../../../../utils/exportExcel";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

interface SeccionDividendosComponentProps {
  title: string;
  nameFile: string;
  month: number;
  year: number;
  cuadrado: boolean;
}

const urlTabla = `siscred-api-cartera-total/v1/dividendos/cuadrar`;

export const SeccionDividendosComponent = ({ title, nameFile, month, year, cuadrado }: SeccionDividendosComponentProps) => {

  const params = useMemo(() => {
    const p = new URLSearchParams();
    p.set("mes", month.toString());
    p.set("anio", year.toString());
    p.set("cuadrado", cuadrado.toString());
    return p;
  }, [month, year]);


  const dataTable = useDataFetch(
    urlTabla,
    params,
    true,
  );

  const { COLUMNS } = useColumnsDividendosCuadrados({ controlTabla: dataTable });
  const columns = useMemo(() => COLUMNS, [dataTable]);

  useEffect(() => {
    // Solo los parámetros esenciales para comparar
    const essentialParams = `mes=${month}&anio=${year}&cuadrado=${cuadrado}`;
    
    if (!dataTable.params.toString().includes(essentialParams)) {
      dataTable.fetchData(0); // Resetear a página 1 y cargar nuevos datos
      
      dataTable.manejarCambiosFiltros('mes', month.toString());
      dataTable.manejarCambiosFiltros('anio', year.toString());
      dataTable.manejarCambiosFiltros('cuadrado', cuadrado.toString());
    }
  }, [month, year, cuadrado]);

  return (
    <CustomAccordion title={title} expandedDefault>
      <Suspense>
        <Tabla
          columns={columns}
          control={dataTable}
          url={urlTabla}
          titulo={
            <TableHeader
              title=""
              control={dataTable}
              buttonExport={
                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                <MButton
                  type="button"
                  variant="outlined"
                  onClick={() => exportExcel(dataTable.data, columns, nameFile)}
                  startIcon={<SummarizeTwoToneIcon />}
                >
                  Exportar
                </MButton>
                </PermissionGuard>
              }
            />
          }
        />
      </Suspense>
    </CustomAccordion>
  );
};
